export enum CardMessageType {
  ERROR = 'error',
  INFO = 'info',
}

export interface CardMessageProps {
  message: string;
  type: CardMessageType;
}
